export interface PriceRow {
  service: string;
  from: string;
  note: string;
  icon: string;
}

export const priceRows: PriceRow[] = [
  { service: "Local call-out", from: "£65", note: "Assessment and quote for local jobs.", icon: "ri-map-pin-2-line" },
  { service: "Fault finding", from: "£85", note: "Tracking trips, dead sockets and faulty circuits.", icon: "ri-search-eye-line" },
  { service: "Socket or switch replacement", from: "£55", note: "Per fitting, parts extra where needed.", icon: "ri-plug-line" },
  { service: "Light fitting installation", from: "£75", note: "Standard pendants, spots and wall lights.", icon: "ri-lightbulb-line" },
  { service: "Consumer unit inspection", from: "£95", note: "Visual check and RCD testing.", icon: "ri-dashboard-3-line" },
  { service: "Landlord electrical safety check", from: "£140", note: "Full EICR for flats and small houses.", icon: "ri-file-text-line" },
  { service: "Small commercial visit", from: "£95", note: "Shops, cafés and small office jobs.", icon: "ri-store-2-line" },
];